export interface FacilitatorDetails {
  facilitatorId: string;
  facilitatorName: string;
  functionName: string;
  functionId: string;
  assignmentDate: string;
  coachTypeAssignmentId?: string;
}

export enum FacilitatorListKeys {
  functionName = "functionName",
  facilitatorName = "facilitatorName",
  assignmentDate = "assignmentDate",
}

export const AddFacilitatorFormKeys = {
  function: "function",
  facilitator: "facilitator",
} as const;
